import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { IconComponent } from "../icon/icon.component";
import { IsMobileService } from '../../service/is-mobile.service';
import { MatDividerModule } from '@angular/material/divider';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-input',
    imports: [MatButtonModule, IconComponent, MatDividerModule, FormsModule],
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.less'
})
export class SearchInputComponent implements AfterViewInit, OnDestroy {

  isMobile = inject(IsMobileService)

  @Input() placeholder = "Search";
  @Input() value = "";
  @Input() suggestions: string[] = [];
  @Input() noSearchView = false;

  public showingSuggestions = false;

  @Output() inputChange = new EventEmitter<string>();
  @Output() search = new EventEmitter<string>();

  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  @ViewChild('searchView') searchView!: ElementRef<HTMLDialogElement>;
  @ViewChild('searchViewInput') searchViewInput!: ElementRef<HTMLInputElement>;
  @ViewChild('container') container!: ElementRef<HTMLElement>;

  private focusTimeout: any;

  ngAfterViewInit() {
    // Add focus event listeners to track focus within the container
    this.container.nativeElement.addEventListener('focusin', this.handleFocusIn.bind(this));
    this.container.nativeElement.addEventListener('focusout', this.handleFocusOut.bind(this));
  }

  ngOnDestroy() {
    // Clean up event listeners
    this.container.nativeElement.removeEventListener('focusin', this.handleFocusIn.bind(this));
    this.container.nativeElement.removeEventListener('focusout', this.handleFocusOut.bind(this));
    if (this.focusTimeout) {
      clearTimeout(this.focusTimeout);
    }
  }

  private handleFocusIn(event: FocusEvent) {
    // Clear any pending timeout to hide suggestions
    if (this.focusTimeout) {
      clearTimeout(this.focusTimeout);
      this.focusTimeout = null;
    }
    
    // Show suggestions when focus enters the container
    if (!this.isMobile.getIsMobile()) {
      this.showingSuggestions = true;
    }
  }

  private handleFocusOut(event: FocusEvent) {
    // Use a small delay to allow focus to move within the container
    this.focusTimeout = setTimeout(() => {
      // Check if the new focus target is still within the container
      const relatedTarget = event.relatedTarget as HTMLElement;
      if (!relatedTarget || !this.container.nativeElement.contains(relatedTarget)) {
        // Only hide suggestions if focus has moved completely outside the container
        this.showingSuggestions = false;
      }
    }, 10);
  }

  openSearchView() {

    if (this.noSearchView) {
      return;
    }

    if (this.isMobile.getIsMobile()) {
      this.input.nativeElement.blur();
      this.searchView.nativeElement.showModal();
      this.searchViewInput.nativeElement.focus();
      this.preventBackgroundScroll();
    }
  }

  closeSearchView() {
    if (this.noSearchView) {
      return;
    }
    this.searchView.nativeElement.close();
    this.restoreBackgroundScroll();
  }

  private preventBackgroundScroll() {
    document.body.style.overflow = 'hidden';
  }

  private restoreBackgroundScroll() {
    document.body.style.overflow = '';
  }

  emitInputChange(event: Event) {
    this.value = (event.target as HTMLInputElement).value;
    this.inputChange.emit(this.value);
  }

  emitSearch() {
    this.search.emit(this.value);
    this.closeSearchView();
  }
}
